import React, { useGlobal } from 'reactn';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import HomeIcon from '@material-ui/icons/Home';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import Divider from "@material-ui/core/Divider";
import { FormControl, InputLabel } from '@material-ui/core';
// import DateFnsUtils from '@date-io/date-fns';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import axios from 'axios'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  footer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: "100%"
  },
  title: {
    flexGrow: 1,
  },
  staffcard: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: "1%",
    textAlign: "left",
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "primary",
    // outline: "1px solid orange",
    margin: "5px 5px",
  },
  cardTitle: {
    fonSize: "1.5rem",
  },
  barcodepanel: {
    display: "flex",
    flexDirection: "column",
  },
  barcode: {
    width: "50%",
    paddingLeft: "25%",
  },
  datapanel: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    // width: "85%",
  },
  uploadPanel: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    // outline: "1px solid orange",
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  scanDetails: {
    display: "flex",
    flexDirection: "column",

  },
  subheading: {
    backgroundColor: "#a2a2a2",
    color: "white",
  },
  button: {
    width: "50%",
    marginLeft: "25%",
  },
  reasonDisplay: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  selects: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
  }

}));

export const AdminView = (props) => {
  const classes = useStyles();
  const [profileMenu, setProfileMenu] = React.useState(null);
  const [user, setuser] = useGlobal('user');
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState('success');
  const [alertMessage, setAlertMessage] = React.useState('');

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedValues(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleLogOut = () => {
    localStorage.clear();
    setuser({
      user: {
        username: null,
        telephone: null,
        name: null,
        address: null,
        token: null,
      }

    })
    props.history.push('/');
  }

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlertOpen(false);
  };

  const handleCreateRecords = async () => {
    try {
      setLoading(true);
      console.log("user token", user.token)
      const result = await axios.post(`${process.env.REACT_APP_URL}/bulk/addElementaryStandards`, {
        gradeBands: selectedValues,
      },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      console.log("result ", result);
      setAlertOpen(true);
      setAlertMessage(`Processed  x records`)
      setLoading(false)
    } catch (e) {
      setAlertOpen(true);
      setAlertMessage(`Error processing ${e.message}`)
      setLoading(false)
    }

  }
  return (
    <div>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            onClick={() => props.history.push('/')}
            color="inherit"
          >
            <HomeIcon fontSize="large" />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Admin
          </Typography>

          <IconButton
            edge="end"
            // className={classes.menuButton} 
            color="inherit" aria-label="menu"
            onClick={e => setProfileMenu(e.currentTarget)}>
            {/* <AccountCircleIcon 
                   aria-controls="profile-menu" aria-haspopup="true"
                   fontSize="large"
                   /> */}
            <MenuIcon
              aria-controls="profile-menu" aria-haspopup="true"
              fontSize="large"
            />
          </IconButton>
          <Menu
            id="profile-menu"
            anchorEl={profileMenu}
            keepMounted
            open={Boolean(profileMenu)}
            onClose={e => setProfileMenu(null)}
          >
            {/* <MenuItem onClick={() => props.history.push('/addstudents')}>Update Students</MenuItem> */}
            <MenuItem onClick={() => props.history.push('/middlegrading')}>Middle School Comments</MenuItem>
            <MenuItem onClick={() => props.history.push('/mprinting')}>Middleschool Print  Reports</MenuItem>
            <MenuItem onClick={() => props.history.push('/printing')}>Elementary Print Reports</MenuItem>
            <MenuItem onClick={() => props.history.push('/upload')}>Upload Trimester Grades</MenuItem>
            <MenuItem onClick={() => props.history.push('/uploadattendance')}>Upload Trimester attendance</MenuItem>
            <MenuItem onClick={handleLogOut}>Logout</MenuItem>
          </Menu>
          {/* <AccountCircleIcon fontSize="large" onClick={() => props.history.push('/profile')}></AccountCircleIcon> */}
        </Toolbar>
      </AppBar>
      <div style={{ display: "flex", flexDirection: "column", height: "500px", justifyContent: "center", alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: "100%", height: "50px" }}>
          <p>
            Create all Elementary Standards

          </p>
          <div>
            <FormControl >
              <InputLabel id="multi-select-label">Options</InputLabel>
              <Select
                labelId="multi-select-label"
                id="multi-select"
                multiple
                value={selectedValues}
                onChange={handleChange}
                renderValue={(selected) => "Selected"} // Optional: customize how selected values are displayed
              >
                <MenuItem value="K">
                  <Checkbox checked={selectedValues.indexOf("K") > -1} />
                  <ListItemText primary="Kindergarten" />
                </MenuItem>
                <MenuItem value="1">
                  <Checkbox checked={selectedValues.indexOf("1") > -1} />
                  <ListItemText primary="1st Grade" />
                </MenuItem>
                <MenuItem value="2">
                  <Checkbox checked={selectedValues.indexOf("2") > -1} />
                  <ListItemText primary="2nd Grade" />
                </MenuItem>
                <MenuItem value="3">
                  <Checkbox checked={selectedValues.indexOf("3") > -1} />
                  <ListItemText primary="3rd Grade" />
                </MenuItem>
                <MenuItem value="4">
                  <Checkbox checked={selectedValues.indexOf("4") > -1} />
                  <ListItemText primary="4th Grade" />
                </MenuItem>
                <MenuItem value="5">
                  <Checkbox checked={selectedValues.indexOf("5") > -1} />
                  <ListItemText primary="5th Grade" />
                </MenuItem>

              </Select>
            </FormControl>

          </div>
          <button onClick={() => handleCreateRecords()} >{!loading ? "Go" : "Updating"}</button>
        </div>
      </div>
      <Snackbar open={alertOpen} autoHideDuration={3000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity={severity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div >
  )
}